import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  hidden: {
    display: 'none !important'
  },
  editorFormRowDisplay: {
    minWidth: 0,
    width: '100%'
  },
  editorFormRowValue: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.grey[400],
    fontWeight: theme.typography.fontWeightRegular
  },
  cursorPointer: {
    cursor: 'pointer'
  },
  cursorNotAllowed: {
    cursor: 'not-allowed',
    color: theme.palette.grey[400]
  }
}));

export const Display = ({ preview, disabled, onEdit, visible, help, previewClickable }) => {
  const classes = useStyles();
  return (
    <div onClick={disabled || !previewClickable ? null : onEdit} className={visible ? classes.editorFormRowDisplay : classes.hidden}>
      {help || null}
      <span
        className={classnames(
          disabled ? classes.cursorNotAllowed : classes.cursorPointer,
          classes.editorFormRowValue
        )}
      >
        {preview}
      </span>
    </div>
  );
};

Display.propTypes = {
  help: PropTypes.node,
  preview: PropTypes.any,
  onEdit: PropTypes.func,
  visible: PropTypes.bool
};

export default Display;
